// Import component
import MapWidgetMap from './components/MapWidgetMap.vue';

const mapsWidgetApp = {
    components: {
        MapWidgetMap,
    },
    data() {
        return {
            dataLocations: [],
        };
    },
    mounted() {
        if (this.$el.dataset.locations) this.dataLocations = JSON.parse(this.$el.dataset.locations);
    },
};

export default mapsWidgetApp;
